import { render, staticRenderFns } from "./SendProposal.html?vue&type=template&id=58a17679&"
import script from "./SendProposal.js?vue&type=script&lang=js&"
export * from "./SendProposal.js?vue&type=script&lang=js&"
import style0 from "./SendProposal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports